<template>
	<section class="view-onboarding-welcome" id="view-onboarding-welcome">
		<section class="background-video">
			<video autoplay loop muted playsinline>
				<source src="@/Asset/video/onboarding-background.webm" type="video/webm" />
				<source src="@/Asset/video/onboarding-background.mp4" type="video/mp4" />
			</video>
		</section>

		<section class="branding">
			<img
				alt="ChalkySticks Logo"
				class="logo filter-invert"
				src="~@chalkysticks/sass/build/asset/image/icon/chalkysticks.svg"
			/>

			<h1 class="title">
				<strong>Chalky</strong>
				<span>Sticks</span>
			</h1>
		</section>

		<section class="actions">
			<ViewUiButtonGetStarted v-on:continue="$emit('continue')" />
		</section>

		<footer>
			By using ChalkySticks you agree to our
			<br />
			<a href="https://www.chalkysticks.com/terms-of-use" target="_blank">Terms</a>
			and
			<a href="https://www.chalkysticks.com/privacy-policy" target="_blank">Privacy</a>
			policies.
		</footer>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Onboarding
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewOnboardingWelcome extends ViewBase {
		// Not implemented
	}
</script>

<style lang="scss">
	#view-onboarding-welcome {
		align-items: flex-start;
		background-image: url('@/Asset/image/onboarding/onboarding-background-00.avif');
		grid-template-rows: 1fr min-content min-content;
		text-align: center;

		.background-video {
			background-color: var(--chalky-blue-4);
			position: absolute;
			inset: 0;
			z-index: -1;

			video {
				height: 100%;
				object-fit: cover;
				opacity: 0.5;
				width: 100%;
			}
		}

		.branding {
			position: relative;
			top: 30%;
			translate: 0 -50%;

			.logo {
				height: 60px;
			}
		}

		.title {
			font-size: 3rem;
			font-weight: 300;
			letter-spacing: -0.05rem;

			strong {
				font-weight: 700;
			}
		}

		.subtitle {
			color: var(--chalky-grey-2);
		}

		.actions {
			padding: 1rem;
		}

		footer {
			padding: 0 1rem 3rem 1rem;
		}
	}
</style>
